import React, { KeyboardEventHandler } from "react";
import cn from "classnames";
import s from "./Toggle.module.scss";

interface IOwnProps {
  left?: string;
  right?: string;
  position: "LEFT" | "RIGHT";
  onClick?: (position: "LEFT" | "RIGHT") => void;
  testId?: string;
  disabled?: boolean;
}

export const Toggle = ({
  left,
  right,
  position,
  onClick,
  testId,
  disabled,
}: IOwnProps) => {
  const onToggle = () =>
    disabled ? undefined : onClick?.(position === "LEFT" ? "RIGHT" : "LEFT");

  const onKeyDown: KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      onToggle();
    }
  };

  return (
    <div className={cn(s.surround)}>
      <label className={cn(position === "LEFT" && s.active)}>{left}</label>
      <div
        className={cn(s.toggle, disabled && s.disabled)}
        onClick={onToggle}
        onKeyDown={onKeyDown}
        role={"button"}
        tabIndex={0}
        data-testid={testId}
      >
        <div
          className={cn(
            s.marker,
            position === "LEFT" && s.left,
            position === "RIGHT" && s.right
          )}
        />
      </div>
      <label className={cn(position === "RIGHT" && s.active)}>{right}</label>
    </div>
  );
};
